/**
 * @generated SignedSource<<a7c31509287a7060abc4b08233802330>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LocationsListItemDeleteButton_location$data = {
  readonly address: string;
  readonly id: string;
  readonly " $fragmentType": "LocationsListItemDeleteButton_location";
};
export type LocationsListItemDeleteButton_location$key = {
  readonly " $data"?: LocationsListItemDeleteButton_location$data;
  readonly " $fragmentSpreads": FragmentRefs<"LocationsListItemDeleteButton_location">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LocationsListItemDeleteButton_location",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    }
  ],
  "type": "BrandLocationType",
  "abstractKey": null
};

(node as any).hash = "ce09c46fa98f9096dc15a3d408a4275d";

export default node;
